<template>
  <div class="stations-view">
    <StationMap class="station-map" :stations="stations" @station-clicked="stationClicked" />
    <StationCard v-if="selectedStation" class="station-card" :station="selectedStation" />
  </div>
</template>

<i18n>
  {
    "es": {
      "error-retrieving-stations": "Se produjo un error buscando las estaciones Recyco. Por favor recargue la aplicación y si el problema persiste, intente nuevamente más tarde."
    },
    "en": {
      "error-retrieving-stations": "An error ocurred while finding Recyco stations. Please reload the app and if the problem persists, try again later."
    }
  }
</i18n>

<script>
  import gql from 'graphql-tag';

  import StationMap from '@/components/StationMap.vue';
  import StationCard from '@/components/StationCard.vue';

  export default {
    name: 'stations-view',
    components: {
      StationMap,
      StationCard,
    },
    data() {
      return {
        stations: [],
        selectedStationId: null,
      };
    },
    apollo: {
      stations: {
        query: gql`query stations {
          stations {
            uuid
            name
            organization {
              uuid
              name
            }
            phoneNumber
            location
            address
          }
        }`,
        update: ({ stations }) => stations,
        error() {
          alert(this.$t('error-retrieving-stations'));
        },
        fetchPolicy: 'cache-and-network',
      },
    },
    methods: {
      stationClicked(stationId) {
        this.selectedStationId = stationId;
      },
    },
    computed: {
      selectedStation() {
        return this.stations ? (this.stations.find(({ uuid }) => uuid === this.selectedStationId) || null) : null;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/mixins.scss';

  .stations-view {
    position: relative;
  }

  .heading {
    margin-left: 1rem;
    margin-right: 1rem;
    margin-block-start: calc(0.67em + 1rem);
    z-index: 100000;
  }

  .station-map {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 0;

    width: 100%;
    height: 100%;
  }

  .station-card {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 1em;

    padding: 1em;

    cursor: pointer;
  }
</style>
